import { Provider } from '@angular/core';
import { environment } from '@environments/environment';
import {
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
} from 'keycloak-angular';

// Matches both the relative backend url and the absolute url produced by ApiBaseHttpInterceptor.
const backendApiCondition =
  createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: new RegExp(`^(https?://[^/]+)?${environment.backendBaseUrl}/`),
  });

export const provideKeycloakBearerToken = (): Provider => ({
  provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  useValue: [backendApiCondition],
});
